// =============================================
// GLOBAL CONSTANTS / MOCK DATA / UTILS
// =============================================
const mockMessages = [
    {
        role: 'assistant',
        content: 'Please select a chatbot to start the conversation.',
        text: 'Please select a chatbot to start the conversation.'
    },
];

// Helper to generate standardized unique chatbot ID
const generateUniqueChatbotId = () => `chatbot_${Math.floor(Math.random() * 100000)}_${new Date().toISOString().replace(/[-:.TZ]/g, "")}`;

// Helper to check if chatbot ID follows standardized format
const isStandardizedChatbotId = (id) => {
    if (!id) return false;
    // Pattern: chatbot_XXXXX_YYYYMMDDHHMMSS (5 digit random + ISO timestamp without special chars)
    const pattern = /^chatbot_\d{1,6}_\d{14,}$/;
    return pattern.test(id);
};

export { mockMessages, generateUniqueChatbotId, isStandardizedChatbotId };